<template>

	<nav class="navbar navbar-default">
  <div class="container-fluid">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" href="#">
      	<!-- <img class="logo-img" alt="Tourbillon" src="./assets/logo.png"> -->
        Tourbillon
      </a>
    </div>

    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
      <ul class="nav navbar-nav">

      <li><router-link :to="{name: 'simple'}">Simple</router-link></li>
      <li><router-link :to="{name: 'query'}">Queries</router-link></li>

      <div class="navbar-form navbar-left" style="margin-top: 1.25rem">
        <div class="form-group form-group-sm">
          <Datepicker placeholder="Start date" v-model="start" :format="format" autoApply class="inline"></Datepicker>
          <Datepicker placeholder="End date" v-model="end" :format="format" autoApply class="inline"></Datepicker>
        </div>
      </div>

      <li class="dropdown" v-if="$store.state.auth.superuser">
        <a
        	href="#"
        	class="dropdown-toggle"
        	data-bs-toggle="dropdown"
        	role="button"
        	aria-haspopup="true"
        	aria-expanded="false">Administration <span class="caret"></span>
    	  </a>
        <ul class="dropdown-menu">
          <li><router-link :to="{name: 'rules'}">Access Rules</router-link></li>
        </ul>
      </li>

      </ul>

      <ul class="nav navbar-nav navbar-right">
        <li class="dropdown">
          <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" role="button">
          {{username}}
          <span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li><router-link :to="{name: 'profile'}">View Profile</router-link></li>
          </ul>
        </li>
      </ul>
    </div><!-- /.navbar-collapse -->
  </div><!-- /.container-fluid -->
</nav>

</template>
<script type="text/javascript">

import moment from 'moment'

export default {
  async beforeMount() {
    await this.$store.dispatch("login")
  },
  data() {
    return {
      start: this.$store.state.basket.start,
      end: this.$store.state.basket.end,
      format: "yyyy-MM-dd",
    }
  },
  computed: {
    username() {
      return this.$store.state.auth.username
    }
  },
  watch: {
    start(value){
      if(value){
        value = moment(value).startOf('day').toISOString()
      }
      this.$store.dispatch('setGlobalStartDate', value)
    },
    end(value){
      if(value){
        value = moment(value).startOf('day').toISOString()
      }
      this.$store.dispatch('setGlobalEndDate', value)
    },
  }
}

</script>

<style scoped>
  .inline {
    display: inline-block;
  }
</style>
